<template>

    <header :class="classname">

        <!-- Loading -->
        <loading/>

        <div class="d-flex justify-content-between order-2 col-12 p-0 m-0 module_actions" id="module_actions" style="height:3rem;">

            <select 
                v-model="orderby" 
                class="form-select order-1 col-4 p-0 m-0" 
                aria-label="Order Data" 
                @change="orderValue()"
                style="width:30%;"
            >
                <option selected>Order</option>
                <option value="asc">ASC</option>
                <option value="desc">DESC</option>
            </select>

            <div class="order-1 col-4 p-0 m-0">

                <slot name="custom_action"></slot>

            </div>

            <div class="input-group order-3 col-4 p-0 m-0" style="width:30%;">
                <input 
                    type="text" 
                    class="form-control" 
                    v-model="searchInput" 
                    placeholder="search by title, id or created date" 
                    aria-label="Inform parameters to search" 
                    aria-describedby="search-module"
                    @keydown.delete="cleanSearchInput($event)"
                    @keyup.delete="cleanSearchInput($event)"
                    @keydown.enter="searchValue()"
                >
                <button 
                    @click="searchValue()" 
                    class="btn btn-outline-secondary" 
                    type="button" 
                    id="search-module"
                >Search</button>
            </div>

        </div> 
    
    </header>

</template>
<script>

    import fetchData from './../../fetchData.js';
    import Loading from './LoadingElement.vue';
    import inputValidation from './../../validationInputs.js';

    export default{
        name: 'ModuleActionElement',
        emits: ['dynamic-data'],
        props:{

            csrftolken:{
                type: String,
                required: true
            },
            alldata:{
                type: String,
                required: true
            },
            orderurl:{
                type: String,
                required: true
            },
            searchurl:{
                type: String,
                required: true
            },
            classname:{
                type: String,
                required: true
            }

        },
        data: () => {

            return {

                orderby: 'Order',
                searchInput: '',
                searchData: {},
                dynamicData: {},
                orderData: {},
                validationSearchtype: '',
                searchDataType: '',
                moduleData: {}

            }

        },
        created(){

            //Set Module Data
            this.moduleData = JSON.parse(this.alldata);

        },
        methods:{

            orderValue(){

                //List of Order Values
                let listOfOrderValues = ['asc', 'desc'];

                //Only Send Order Values
                if(!listOfOrderValues.includes(this.orderby)){

                    return;

                }

                //Clean Data
                this.orderData = {};

                //Active Loading
                document.querySelector('.loadingbase').classList.add('d-flex');

                //Get Data from Url
                let response = fetchData.structureTosendData(this.orderurl, {orderby: this.orderby}, this.csrftolken, 'POST');

                //Resolve Promise
                response.then((value) => {

                    //Set Search Review attData
                    if(value.hasOwnProperty('attData')){

                        //Desactive Loading
                        document.querySelector('.loadingbase').classList.remove('d-flex');

                        //Set Data
                        this.orderData = JSON.parse(value.attData);

                        //Set Dynamic Data
                        this.dynamicData = this.orderData;

                        //Set Default Value for orderBy
                        this.orderby = 'Order';

                        //Set Defaul Module Data
                        return this.$emit('dynamic-data', this.dynamicData);

                    }

                }).catch((error) => {

                    //Desactive Loading
                    document.querySelector('.loadingbase').classList.remove('d-flex');

                    //Set Defaul Module Data
                    this.$emit('dynamic-data', this.dynamicData);

                    //Set Error Message
                    throw new Error(error);

                });

            },
            cleanSearchInput(element){

                //Check Empty Value from InputSearch
                if(this.searchInput === '' && Object.values(this.searchData).length > 0){

                    //Clean Data
                    this.searchData = {};

                    //Set Defaul Module Data
                    return this.$emit('dynamic-data', this.moduleData);

                }

                //Set Defaul Module Data
                return this.$emit('dynamic-data', {});

            },
            getSearchDataTypeCase(data, conditional, validationcase){

                //Data Type Conditional
                if(data.includes(conditional)){

                    //Set dynamic input validation case
                    this.validationSearchtype = validationcase;

                }

            },
            errorSearchMessage(message){

                //Clean Variable
                this.searchInput = '';

                //Show Error Message
                alert(message);

                //Desactive Loading
                document.querySelector('.loadingbase').classList.remove('d-flex');

                return;

            },
            getSearchDataType(casetype){

                switch(casetype){

                    //String
                    case 1:

                        this.searchDataType = 'string';

                    break;

                    //Number
                    case 2:

                        this.searchDataType = 'number';

                    break;

                    //Email
                    case 7:

                        this.searchDataType = 'email';

                    break;

                    //Date
                    case 9:

                        this.searchDataType = 'date';

                    break;

                }

            },
            searchValue(){

                //Active Loading
                document.querySelector('.loadingbase').classList.add('d-flex');

                //Clean Data
                this.searchData = {};

                //Get InputValidation Case
                this.getSearchDataTypeCase(this.searchInput.trim(), '@', 7);

                //Second check for input validation case
                if(this.validationSearchtype === ''){

                    this.getSearchDataTypeCase(this.searchInput.trim(), '/', 9);
                    this.getSearchDataTypeCase(this.searchInput.trim(), '-', 9);

                }

                //Check by number
                if(Number.isInteger(parseInt(this.searchInput.trim())) && this.validationSearchtype === ''){

                    //Only Numbers
                    this.validationSearchtype = 2;

                }

                //Check String
                if(!Number.isInteger(parseInt(this.searchInput.trim())) 
                && !this.searchInput.trim().includes('@') 
                && !this.searchInput.trim().includes('/') 
                && this.validationSearchtype === ''){

                    //Only Letters, special chars and white space
                    this.validationSearchtype = 1;

                }

                //Validate Url 
                let checkSearchData = inputValidation.validNameCases(this.validationSearchtype, this.searchInput.trim());

                //Check Url
                if(!checkSearchData){

                //Error Message
                this.errorSearchMessage('Please insert a valid input to search');

                return;

                }

                //Set Search Data Type
                this.getSearchDataType(this.validationSearchtype);

                //Clean ValidationSearch type
                this.validationSearchtype = '';

                //Get Data from Url
                let response = fetchData.structureTosendData(this.searchurl, {searchdata: this.searchInput.trim(), searchtype: this.searchDataType}, this.csrftolken, 'POST');

                //Resolve Promise
                response.then((value) => {

                    //Set Search Review attData
                    if(value.hasOwnProperty('attData')){

                        //Desactive Loading
                        document.querySelector('.loadingbase').classList.remove('d-flex');

                        //Clean Variable
                        //this.searchInput = '';
                        this.searchDataType = '';

                        //Message Error
                        if(value.attData.length === 0){

                            //Show Message
                            alert(value.message);

                            return;

                        }

                        //Set Data
                        this.searchData = JSON.parse(value.attData);

                        //Set Dynamic Data
                        this.dynamicData = this.searchData;

                        //Set Defaul Module Data
                        return this.$emit('dynamic-data', this.dynamicData);

                    }

                }).catch((error) => {

                    //Desactive Loading
                    document.querySelector('.loadingbase').classList.remove('d-flex');

                    //Clean Variable
                    //this.searchInput = '';
                    this.searchDataType = '';

                    //Set Defaul Module Data
                    this.$emit('dynamic-data', this.dynamicData);

                    //Set Error Message
                    throw new Error(error);

                });

            },

        },
        computed:{

            computedSearchData(){

                return this.searchData;

            },
            computedDynamicData(){

                return this.dynamicData;

            },
            computedOrderData(){

                return this.orderData;

            },
            computedSearchInputValidationType(){

                return this.validationSearchtype;

            },
            computedGetSearchDataType(){

                return this.searchDataType;

            },


        },
        watch:{

            computedSearchData(){},
            computedDynamicData(){},
            computedOrderData(){},
            computedSearchInputValidationType(){},
            computedGetSearchDataType(){}

        },
        components:{

            loading: Loading

        }

    }

</script>